import React, { useState, useEffect } from 'react';

import { AppData } from '../../../data/index'

export const useGetSportFinishPatchImages = () => {
    const [images, setImages] = useState([])

    useEffect(() => {
        const serverData = AppData?.sportFinishPatchData?.JacketSportFinishPatchConfiguratorOptionData

        if (!serverData?.length) return

        setImages(serverData)
    }, [])

    return [images]
}